<template>

    <div class="container">

        <app-head title="Payment Methods" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Payment Methods') }}</h1>
            <div class="">
                <!--            @todo    <inertia-link class="btn btn-primary" :href="route('admin.payment-methods.create')">
                                    {{ __('Create') }}
                                </inertia-link>-->
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="card">
            <data-table :items="paymentMethods"
                        :columns="columns"
                        >
                <data-table-row v-for="paymentMethod in paymentMethods" :key="paymentMethod.id">
                    <td>
                        {{ paymentMethod.id }}
                    </td>
                    <td>
                        <inertia-link :href="route('admin.payment-methods.edit', paymentMethod)" class="stretched-link">
                            {{ paymentMethod.name }}
                        </inertia-link>
                    </td>
                    <td>
                        <boolean :value="paymentMethod.enabled" />
                    </td>
                    <td>
                        {{ paymentMethod.description }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';

    import Boolean from '@/shared/Admin/Boolean';

    export default {
        props: [
            'filters',
            'paymentMethods',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            Boolean,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
                columns: {
                    id: {label: 'ID'},
                    name: {label: 'Name'},
                    enabled: {label: 'Enabled'},
                    description: {label: 'Description'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.payment-methods.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>